import { deleteLicenseType } from "../../../../../actions/Utilities/LicenseType";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "../../../../../components/toastNotification";

const useDeactivateLicenseType = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation(
    (ids: number[] | undefined) => deleteLicenseType(ids),{
    onSuccess: () => {
      queryClient.invalidateQueries(["GetLicenseType"]);
      toast.fire(
        "Success",
        "License Type were deactivated successfully",
        "success"
      );
    },
    onError: () => {
      toast.fire(
        "Bulk deactivation of LicenseType failed",
        "Server Error: Cannot deactivate License Type",
        "error"
      );
    },
  });

  return mutate;
};
export default useDeactivateLicenseType;
